import { useCallback, useState, useEffect } from "react";
import { useUserContext } from "../../contexts/UserContext";
import { catchError } from "../../services/DaoService";
import { Button, Input, Spin, Empty } from "antd";
import { PlusCircleFilled, ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { MembreTacheService } from "../../services/MembreTacheService";
import MembreTacheCreateForm from "./MembreTacheCreateForm";
import MembreTacheList from "./MembreTacheList";
import PropTypes from "prop-types";
import styles from "./MembreTacheByTacheList.module.scss";

export default function MembreTacheByTacheList({ tache, isReadOnly = true, canManage = false }) {
  const [paginationData, setPaginationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const { check } = useUserContext();
  const [searchText, setSearchText] = useState('');
  const [membreTaches, setMembreTaches] = useState([]);

  const init = useCallback(() => {
    setLoading(true);
    MembreTacheService.getInstance()
      .search({ searchText: searchText || null, statut: "tout", tache_id: tache.id })
      .then(r => { setPaginationData(r.data); setMembreTaches(r.data.data); })
      .catch(catchError)
      .finally(() => setLoading(false));
  }, [searchText, tache]);

  useEffect(() => { init(); }, [init, check]);

  return (
    <div className={styles.section}>
      <div className={styles.toolbar}>
        {paginationData?.total != null && (
          <span className={styles.count}>{paginationData.total}</span>
        )}
        <div className={styles.search}>
          <Input
            prefix={<SearchOutlined style={{ color: '#8C9BAB' }} />}
            placeholder="Rechercher..."
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            size="small"
            allowClear
          />
        </div>
        <div className={styles.actions}>
          <Button size="small" icon={<ReloadOutlined />} onClick={init} />
          {canManage && !isReadOnly && (
            <Button size="small" type="primary" icon={<PlusCircleFilled />} onClick={() => setNewModalVisible(true)}>
              Ajouter
            </Button>
          )}
        </div>
      </div>

      <Spin spinning={loading}>
        {membreTaches.length === 0 && !loading
          ? <div style={{ padding: '16px 14px' }}><Empty description="Aucun observateur" image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>
          : <MembreTacheList
              isReadOnly={isReadOnly}
              canManage={canManage}
              membreTaches={membreTaches}
              setMembreTaches={setMembreTaches}
              paginationData={paginationData ?? { data: [] }}
              setPaginationData={setPaginationData}
              searchParams={{ searchText: searchText || null, statut: "tout", tache_id: tache.id }}
            />
        }
      </Spin>

      {tache && (
        <MembreTacheCreateForm
          tache={tache}
          visible={newModalVisible}
          onCreate={init}
          onCancel={() => setNewModalVisible(false)}
        />
      )}
    </div>
  );
}

MembreTacheByTacheList.propTypes = {
  tache: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  canManage: PropTypes.bool,
};
